// Blocks removed because Hopper has no hardware for them.
//
// Two of these threw a FlightError on Hopper, the flip was a silent no-op
// because Hopper firmware has no handler, and take picture was never
// confirmed. They are gone from the toolbox, both generators, the reverse
// compiler, the linter and the autocomplete.
//
// Projects saved before that still contain them, and someone may still type
// the call in the JavaScript view. Both cases are worth counting: it is the
// only way to know whether anyone is actually still reaching for these.
//
// What is sent is the block name and, if the person says so, that they were
// using it. Nothing else. No identity, no session, no address. The endpoint
// accepts only these four names and stores two integers per name.

export const RETIRED_BLOCKS = [
  'minidrone_flip',
  'minidrone_fire_bb',
  'minidrone_take_picture',
  'minidrone_grabber'
];

// Human labels, for a message that names what the student actually lost
// rather than an internal block id.
export const RETIRED_LABELS = {
  minidrone_flip: 'flip Mini Drone',
  minidrone_fire_bb: 'fire BB',
  minidrone_take_picture: 'take picture',
  minidrone_grabber: 'grabber'
};

// drone.js method name to block name, so a typed call counts the same as a
// dragged block.
export const RETIRED_METHODS = {
  flip: 'minidrone_flip',
  fireGun: 'minidrone_fire_bb',
  takePicture: 'minidrone_take_picture',
  grabber: 'minidrone_grabber'
};

// ---------------------------------------------------------------------------
// Which drone is on the other end.
//
// These blocks never worked on Hopper. A Hopper owner who found one was
// finding a dead end, and their hit is noise. The only people for whom these
// commands ever did anything are Mambo owners, so a count that does not say
// which drone was connected does not answer the question worth asking.
//
// What is sent is the classification only: 'hopper', 'mambo' or 'unknown'.
// Never the device name, which carries a serial number.
// ---------------------------------------------------------------------------

// Prefixes come from the pairing filter in App.vue. FTW_ was the default name
// on the Parrot Mambos FTW shipped between 2018 and 2021, so it groups with
// the Parrot family rather than with Hopper.
const MAMBO_PREFIXES = ['mambo_', 'travis_', 'mars_', 'ftw_'];
const HOPPER_PREFIXES = ['hopper'];

export function classifyDrone (deviceName) {
  const n = String(deviceName || '').toLowerCase();
  if (!n) return 'unknown';
  if (HOPPER_PREFIXES.some(p => n.startsWith(p))) return 'hopper';
  if (MAMBO_PREFIXES.some(p => n.startsWith(p))) return 'mambo';
  return 'unknown';
}

// Set once at pairing, read by every report after it.
let connectedDrone = 'unknown';
export function setConnectedDrone (deviceName) {
  connectedDrone = classifyDrone(deviceName);
  reportDroneConnect(connectedDrone);
  return connectedDrone;
}
export function getConnectedDrone () { return connectedDrone; }

// The population number. How many Mambos still connect to ftwcode.ai at all
// is a bigger question than how many of them touch a retired block, because
// most owners will simply not find the blocks any more rather than go looking.
export function reportDroneConnect (kind) {
  post({ connected: kind });
}

const ENDPOINT = 'https://ftw-robotics.ai/.netlify/functions/retired-block-demand';

export function reportRetired (block, wanted = false) {
  if (!RETIRED_BLOCKS.includes(block)) return;
  post({ block: block, wanted: wanted, drone: connectedDrone });
}

// Fire and forget. A counter must never slow down, interrupt, or fail a
// lesson, so every failure path here is a no-op.
function post (body) {
  try {
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true
    }).catch(() => {});
  } catch (e) { /* offline, blocked, or no fetch. Nothing to do. */ }
}
